import { render } from "./Buka.vue?vue&type=template&id=74aef478"
import script from "./Buka.vue?vue&type=script&lang=js"
export * from "./Buka.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__